import { render, staticRenderFns } from "./LiveEventsBox.vue?vue&type=template&id=315c7ba4&scoped=true&"
var script = {}
import style0 from "./LiveEventsBox.vue?vue&type=style&index=0&id=315c7ba4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c7ba4",
  null
  
)

export default component.exports